/* Lotus Edition accessibility menu.
   Read aloud: reads the whole page, and while it is on, tapping a product, category or any words
   reads just that. Tapping a product a second time opens it.
   Reading speed: slow, normal or fast, from the menu or the Read aloud bar.
   Voice: female or male, using the voices built into the shopper's device.
   Also: larger text, high contrast, stop animations, underline links, text spacing, simple font.
   Choices are saved on this device. */
(function () {
  var root = document.documentElement;
  var KEY = 'lx_a11y';
  var synth = window.speechSynthesis;
  var canSpeak = !!synth && 'SpeechSynthesisUtterance' in window;
  var OPTS = [
    { id: 'listen', label: 'Read aloud', hint: 'Reads the page out loud. Tap anything to hear just that.', speak: true },
    { id: 'text', label: 'Larger text', hint: 'Makes all text bigger' },
    { id: 'contrast', label: 'High contrast', hint: 'Black text on white, stronger outlines' },
    { id: 'motion', label: 'Stop animations', hint: 'Stops slideshows, moving pictures and effects' },
    { id: 'links', label: 'Underline links', hint: 'Makes every link easy to spot' },
    { id: 'spacing', label: 'Text spacing', hint: 'More space between lines, words and letters' },
    { id: 'font', label: 'Simple font', hint: 'Switches to a plain, easy to read font' }
  ];
  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { state = {}; }
  if (!canSpeak) state.listen = false;

  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  function apply() {
    OPTS.forEach(function (o) {
      if (state[o.id]) root.setAttribute('data-a11y-' + o.id, ''); else root.removeAttribute('data-a11y-' + o.id);
    });
    showBar(!!state.listen);
    if (!state.listen) { disarm(); hush(); }
    if (state.motion) {
      document.querySelectorAll('.lx-slider__pause[aria-pressed="false"]').forEach(function (b) { b.click(); });
      document.querySelectorAll('body > canvas').forEach(function (c) { c.remove(); });
    }
  }

  /* ---------- Speaking ---------- */
  var RATES = { slow: 0.6, normal: 0.8, fast: 1 };
  var SPEEDS = ['slow', 'normal', 'fast'];
  var SPEED_NAME = { slow: 'Slow', normal: 'Normal', fast: 'Fast' };
  function speed() { return RATES[state.rate] ? state.rate : 'normal'; }
  /* Voice: each device has its own built-in voices, so we pick the best female or male English voice it has */
  var VOICE_NAME = { female: 'Female', male: 'Male' };
  var VOICE_PREF = {
    female: ['Samantha', 'Ava', 'Allison', 'Susan', 'Zoe', 'Nicky', 'Microsoft Aria', 'Microsoft Jenny', 'Microsoft Michelle', 'Microsoft Zira', 'Google US English', 'Karen', 'Moira', 'Tessa', 'Fiona', 'Serena', 'Kate', 'Victoria', 'Veena', 'Isha', 'Microsoft Neerja', 'Microsoft Heera', 'Microsoft Hazel', 'Microsoft Libby', 'Microsoft Sonia', 'Google UK English Female', 'Catherine', 'Martha'],
    male: ['Daniel', 'Aaron', 'Evan', 'Nathan', 'Alex', 'Tom', 'Microsoft Guy', 'Microsoft Andrew', 'Microsoft Davis', 'Microsoft David', 'Microsoft Mark', 'Microsoft Brian', 'Microsoft Christopher', 'Microsoft Eric', 'Google UK English Male', 'Rishi', 'Arthur', 'Oliver', 'Gordon', 'Lee', 'Microsoft Ryan', 'Microsoft George', 'Microsoft Prabhat', 'Microsoft Ravi']
  };
  var NOVELTY = /bad news|bahh|bells|boing|bubbles|cellos|good news|jester|organ|superstar|trinoids|whisper|wobble|zarvox|albert|junior|ralph|kathy|princess|fred|grandma|grandpa|eddy|flo\b|reed|rocko|sandy|shelley/i;
  var voiceList = [];
  function loadVoices() { try { voiceList = synth.getVoices() || []; } catch (e) { voiceList = []; } }
  if (canSpeak) {
    loadVoices();
    if (synth.addEventListener) synth.addEventListener('voiceschanged', loadVoices); else synth.onvoiceschanged = loadVoices;
  }
  function voiceKind() { return VOICE_NAME[state.voice] ? state.voice : 'female'; }
  function pickVoice(kind) {
    if (!voiceList.length) loadVoices();
    var en = [].filter.call(voiceList, function (v) { return v && /^en/i.test(v.lang || '') && !NOVELTY.test(v.name || ''); });
    var pref = VOICE_PREF[kind] || [], i, j;
    for (i = 0; i < pref.length; i++) for (j = 0; j < en.length; j++) if (en[j].name.toLowerCase().indexOf(pref[i].toLowerCase()) > -1) return en[j];
    var re = kind === 'female' ? /female|woman/i : /\bmale\b|\bman\b/i;
    for (j = 0; j < en.length; j++) if (re.test(en[j].name)) return en[j];
    return null;
  }
  var queue = [], pos = 0;
  var LANG = (document.documentElement.lang || 'en').replace(/^en$/i, 'en-US');
  function chunks(t) {
    t = (t || '').replace(/\s+/g, ' ').trim();
    if (t.length <= 220) return t ? [t] : [];
    var out = [], parts = t.match(/[^.!?]+[.!?]*\s*/g) || [t], cur = '';
    parts.forEach(function (p) {
      if ((cur + p).length > 220 && cur) { out.push(cur.trim()); cur = ''; }
      cur += p;
    });
    if (cur.trim()) out.push(cur.trim());
    return out;
  }
  function hush() { queue = []; pos = 0; if (canSpeak && (synth.speaking || synth.pending)) synth.cancel(); }
  function speakFrom(start) {
    var voice = pickVoice(voiceKind());
    for (var i = start; i < queue.length; i++) {
      (function (k) {
        var u = new SpeechSynthesisUtterance(queue[k]);
        if (voice) { u.voice = voice; u.lang = voice.lang; } else u.lang = LANG;
        u.rate = RATES[speed()];
        u.onstart = function () { pos = k; };
        synth.speak(u);
      })(i);
    }
  }
  /* Say sentences. keep = add to what is already being said instead of starting over. */
  function say(list, keep) {
    if (!canSpeak) return;
    if (!keep) hush();
    if (synth.paused) synth.resume();
    var start = queue.length;
    list.forEach(function (t) { queue = queue.concat(chunks(t)); });
    speakFrom(start);
  }
  /* If something is being read, carry on from the same sentence (used when speed or voice changes) */
  function carryOn() {
    if (!((synth.speaking || synth.pending) && queue.length)) return false;
    var rest = queue.slice(pos);
    synth.cancel();
    queue = rest; pos = 0;
    speakFrom(0);
    return true;
  }
  /* Change reading speed. If something is being read, carry on from the same sentence at the new speed. */
  function setSpeed(v) {
    state.rate = v; save(); syncSpeed();
    if (!canSpeak) return;
    if (!carryOn()) say(['Reading speed: ' + SPEED_NAME[v] + '.']);
  }
  /* Change voice. Says a short line in the new voice, or tells the shopper this device has no such voice. */
  function setVoice(v) {
    state.voice = v; save(); syncVoice();
    if (!canSpeak) return;
    if (carryOn()) return;
    say([pickVoice(v) ? 'Voice: ' + VOICE_NAME[v] + '. This is how I will sound.' : 'Voice: ' + VOICE_NAME[v] + '. This device does not have a ' + v + ' voice, so it will use its usual voice.']);
  }
  function syncVoice() {
    document.querySelectorAll('[data-voice]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-voice') === voiceKind() ? 'true' : 'false');
    });
  }
  function syncSpeed() {
    document.querySelectorAll('[data-speed]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-speed') === speed() ? 'true' : 'false');
    });
    document.querySelectorAll('.lx-read-bar [data-act=speed]').forEach(function (b) {
      b.querySelector('.lx-read-bar__speed').textContent = SPEED_NAME[speed()];
      b.setAttribute('aria-label', 'Reading speed, ' + SPEED_NAME[speed()] + '. Tap to change.');
    });
  }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function spell(code) { return code.split('').join(' '); }
  function clean(html) {
    var d = document.createElement('div');
    d.innerHTML = (html || '').replace(/<(br|\/p|\/li|\/h\d|\/div)[^>]*>/gi, '. ');
    return (d.textContent || '').replace(/\s+/g, ' ').replace(/(\.\s*){2,}/g, '. ').trim();
  }

  /* ---------- What counts as readable words ---------- */
  var SKIP = '[aria-hidden="true"],[hidden],nav,.lx-a11y,.lx-read-bar,script,style,noscript,template,select,dialog:not([open])';
  var BLOCKS = 'h1,h2,h3,h4,h5,p,li,dt,dd,summary,blockquote,figcaption,td,th,[class*="price"],.lx-pdp-code';
  function shown(el) {
    if (!el || !el.getClientRects().length || el.closest(SKIP)) return false;
    var c = getComputedStyle(el);
    return c.visibility !== 'hidden' && c.display !== 'none';
  }
  /* Plain words: old prices read as "was", hidden decorations dropped, capital-letter styling ignored */
  function textOf(el) {
    var c = el.cloneNode(true);
    c.querySelectorAll('s,del').forEach(function (x) { x.textContent = ', was ' + x.textContent; });
    c.querySelectorAll('[aria-hidden="true"],svg,script,style').forEach(function (x) { x.remove(); });
    return (c.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function pageText() {
    var main = document.querySelector('main') || document.body, out = [], seen = {}, picked = [];
    main.querySelectorAll(BLOCKS).forEach(function (el) {
      if (!shown(el)) return;
      for (var i = 0; i < picked.length; i++) if (picked[i].contains(el)) return;
      var t = textOf(el);
      if (!t || seen[t]) return;
      seen[t] = 1; picked.push(el); out.push(t);
    });
    return out;
  }
  /* Bangle sizes like 2.10 are said "2 point 10", not "2 point 1" */
  function sayVal(name, v) { return /size/i.test(name) && /^\d+\.\d+$/.test(v) ? v.replace('.', ' point ') : v; }
  /* Size or color row on a product page: name, choices and what is picked */
  function readOption(opt) {
    var fs = opt.tagName === 'FIELDSET' ? opt : null, nameEl = fs && fs.querySelector('legend');
    var c = (nameEl || opt).cloneNode(true);
    c.querySelectorAll('.variant-option__swatch-value').forEach(function (x) { x.remove(); });
    var lab = opt.querySelector('label'), sel = opt.querySelector('select');
    var name = ((sel && lab ? lab.textContent : textOf(c)) || 'Option').replace(/\s+/g, ' ').trim();
    if (sel) {
      var vals = [].map.call(sel.options, function (o) { return sayVal(name, o.textContent.trim()); });
      return name + ' choices: ' + vals.join(', ') + '. Selected: ' + sayVal(name, sel.options[sel.selectedIndex].textContent.trim()) + '.';
    }
    var ins = opt.querySelectorAll('input[type="radio"]');
    if (!ins.length) {
      var one = opt.querySelector('.variant-option__swatch-value');
      var v = one ? one.textContent.trim() : '';
      return name + (v ? ' ' + sayVal(name, v) : '') + '. This is the only ' + name.toLowerCase() + '.';
    }
    var list = [], picked = '';
    ins.forEach(function (i) {
      var v = sayVal(name, i.value) + (i.getAttribute('aria-disabled') === 'true' ? ' sold out' : '');
      list.push(v);
      if (i.checked) picked = v;
    });
    return name + ' choices: ' + list.join(', ') + '.' + (picked ? ' Selected: ' + picked + '.' : '') + ' Tap a ' + name.toLowerCase() + ' to choose it.';
  }
  function readPage() {
    disarm();
    var parts = pageText();
    if (!parts.length) return;
    say(['Reading this page. Tap anything to hear just that.'].concat(parts));
  }

  /* ---------- Products ---------- */
  var armed = null;
  function disarm() { if (armed) armed.classList.remove('lx-read-armed'); armed = null; }
  function readProduct(a) {
    var card = a.closest('.lx-card, .lx-strip__item') || a;
    var titleEl = card.querySelector('.lx-card__title');
    var img = a.querySelector('img[alt]:not([alt=""])') || card.querySelector('img[alt]:not([alt=""])');
    var name = titleEl ? titleEl.textContent.trim() : ((img && img.alt) || a.textContent.trim());
    disarm();
    armed = card; card.classList.add('lx-read-armed');
    say([name + '.']);
    var stock = card.querySelector('.lx-card__stock');
    var offer = card.querySelector('.lx-card__offer');
    fetch(a.pathname.replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (armed !== card) return;
        var bits = [];
        bits.push('Price ' + money(p.price) + (p.compare_at_price > p.price ? ', was ' + money(p.compare_at_price) : '') + '.');
        if (!p.available) bits.push('Sold out.');
        else if (stock) bits.push(stock.textContent.trim() + '.');
        if (offer) bits.push('Offer: ' + offer.textContent.trim() + '.');
        (p.options || []).forEach(function (o) {
          var oname = typeof o === 'string' ? o : o.name, vals = (o && o.values) || [];
          if (!vals.length || (vals.length === 1 && /default/i.test(vals[0]))) return;
          bits.push((vals.length > 1 ? oname + ' choices: ' : oname + ': ') + vals.map(function (x) { return sayVal(oname, x); }).join(', ') + '.');
        });
        if (p.type) bits.push('Type: ' + p.type + '.');
        var v = (p.variants || [])[0] || {};
        var code = (v.sku || '').split('-')[0];
        if (code) bits.push('Item code ' + spell(code) + '.');
        var desc = clean(p.description);
        if (desc) bits.push(desc);
        bits.push('Tap it again to open it, or tap another piece to hear about it.');
        say(bits, true);
      })
      .catch(function () { if (armed === card) say(['Tap it again to open it.'], true); });
  }

  /* ---------- Categories (read after the shop list has been filtered) ---------- */
  function readCategory(el) {
    var label = (el.getAttribute('aria-label') || textOf(el)).replace(/^Discover\s+/i, '').trim();
    var grid = document.getElementById('lx-grid');
    if (!grid) { say([label + '.']); return; }
    var parts = [label + '.'];
    var count = document.getElementById('lx-count');
    if (count && count.textContent.trim()) parts.push(count.textContent.trim() + '.');
    var note = document.getElementById('lx-offer-note');
    if (note && !note.hidden) parts.push(textOf(note));
    var empty = document.getElementById('lx-empty');
    if (empty && !empty.hidden && empty.textContent.trim()) parts.push(empty.textContent.trim());
    grid.querySelectorAll('.lx-card:not(.is-hidden)').forEach(function (c) {
      var t = c.querySelector('.lx-card__title'), pr = c.querySelector('.lx-card__price'), st = c.querySelector('.lx-card__stock');
      if (t) parts.push(t.textContent.trim() + (pr ? ', ' + textOf(pr) : '') + (st ? ', ' + st.textContent.trim() : '') + '.');
    });
    parts.push('Tap any piece to hear its details.');
    say(parts);
  }

  /* ---------- Taps while Read aloud is on ---------- */
  var lastLabel = 0;
  function on() { return state.listen && canSpeak; }
  function ours(t) { return t.closest('.lx-a11y, .lx-read-bar'); }
  /* Product links are caught first, so the first tap reads instead of opening */
  document.addEventListener('click', function (e) {
    if (!on() || !e.target.closest || ours(e.target)) return;
    var a = e.target.closest('a[href*="/products/"]');
    if (!a || e.target.closest('button, form, input, select')) return;
    var card = a.closest('.lx-card, .lx-strip__item') || a;
    if (armed === card) { disarm(); hush(); return; }
    e.preventDefault();
    e.stopPropagation();
    readProduct(a);
  }, true);
  /* ---------- Header: bag, logo, colours, menu, light and dark ---------- */
  var LINK_SAYS = {
    'home': 'Goes to the top of the home page.',
    'shop all': 'Shows every piece we sell.',
    'new in': 'Shows our newest pieces.',
    'categories': 'Shop by bangles, earrings and necklace sets.',
    'our story': 'Tells you about Lotus Edition and the family behind it.',
    'instagram': 'Opens our Instagram page in a new tab.',
    'accessibility statement': 'Explains how we make this website easy to use for everyone.'
  };
  var PAL_SAYS = {
    'classic': 'cream background with olive green',
    'dark': 'dark grey background with lime green',
    'mono-black': 'black background with white words',
    'mono-white': 'white background with black words',
    'black': 'black background with gold',
    'emerald': 'deep emerald green with gold',
    'maroon': 'deep maroon with gold',
    'pink': 'soft pink with rose'
  };
  function linkName(a) { return (a.getAttribute('aria-label') || textOf(a)).replace(/\s*\(opens in new tab\)\s*$/i, '').trim(); }
  function describeLink(a) {
    var name = linkName(a), key = name.toLowerCase();
    if (a.classList.contains('lx-hdr-cart')) return name + '. Opens your bag, where you can check out.';
    if (a.classList.contains('lx-brand')) return 'Lotus Edition logo. Goes to the home page.';
    return name + '.' + (LINK_SAYS[key] ? ' ' + LINK_SAYS[key] : '');
  }
  function menuWords(drawer) {
    var parts = ['Menu opened. ' + drawer.querySelectorAll('a').length + ' options.'];
    drawer.querySelectorAll('a').forEach(function (a) { parts.push(describeLink(a)); });
    parts.push('Tap an option to hear it, then tap it again to go there.');
    return parts;
  }
  function palWords(panel) {
    var opts = panel.querySelectorAll('[data-pal]'), parts = ['Website colours. ' + opts.length + ' choices.'], cur = '';
    opts.forEach(function (o) {
      var n = textOf(o), on = o.getAttribute('aria-checked') === 'true';
      if (on) cur = n;
      parts.push(n + ': ' + (PAL_SAYS[o.getAttribute('data-pal')] || '') + (on ? ', selected.' : '.'));
    });
    parts.push('Tap a colour to use it.' + (cur ? ' Now using ' + cur + '.' : ''));
    return parts;
  }
  /* Links that would leave the page: first tap reads, second tap opens (like products) */
  function leaves(a) {
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^javascript:/i.test(href)) return false;
    if (a.target === '_blank' || a.host !== location.host || a.pathname !== location.pathname) return true;
    if (a.hasAttribute('data-home') && document.getElementById('shop')) return false;
    return !a.hash;
  }
  document.addEventListener('click', function (e) {
    if (!on() || !e.target.closest || ours(e.target)) return;
    var t = e.target;
    /* buttons whose own code reacts first: read after it has changed */
    var hb = t.closest('.lx-pal-btn, [data-pal], .lx-menu-btn, .lx-mode-btn');
    if (hb) {
      e.lxRead = true;
      disarm();
      setTimeout(function () {
        if (hb.classList.contains('lx-pal-btn')) {
          var pp = document.getElementById('lx-pal-panel');
          say(pp && !pp.hidden ? palWords(pp) : ['Colour choices closed.']);
        } else if (hb.hasAttribute('data-pal')) {
          say([textOf(hb) + ' chosen: ' + (PAL_SAYS[hb.getAttribute('data-pal')] || '') + '.']);
        } else if (hb.classList.contains('lx-menu-btn')) {
          var dr = document.getElementById('lx-drawer');
          say(dr && !dr.hidden ? menuWords(dr) : ['Menu closed.']);
        } else {
          var dark = root.getAttribute('data-lx-theme') === 'dark';
          say([(dark ? 'Dark mode on.' : 'Light mode on.') + ' Tap again for ' + (dark ? 'light' : 'dark') + ' mode.']);
        }
      }, 0);
      return;
    }
    var a = t.closest('a[href]');
    if (!a || /\/products\//.test(a.pathname) || !(leaves(a) || a.closest('.lx-drawer'))) return;
    if (armed === a) { disarm(); hush(); return; }
    e.preventDefault();
    e.stopPropagation();
    disarm();
    armed = a; a.classList.add('lx-read-armed');
    say([describeLink(a) + ' Tap it again to ' + (a.target === '_blank' ? 'open it.' : 'go there.')]);
  }, true);

  /* Everything else is read after the page has reacted, so filtered lists are up to date */
  document.addEventListener('click', function (e) {
    if (!on() || e.lxRead) return;
    var t = e.target;
    if (!t.closest || ours(t) || t.closest('a[href*="/products/"]')) return;
    var field = t.closest('input, select, textarea, option');
    if (field) {
      var fopt = field.tagName === 'SELECT' && field.closest('.variant-option');
      if (fopt) { disarm(); say([readOption(fopt)]); return; }
      /* a tap on a choice's label also clicks the choice itself; the label was already read */
      if (Date.now() - lastLabel > 500 && field.labels && field.labels.length) {
        var words = textOf(field.labels[0]), fl = field.type === 'radio' && field.closest('fieldset'), flg = fl && fl.querySelector('legend');
        if (flg) { var fn = textOf(flg); words = fn + ' ' + sayVal(fn, field.value || words) + (field.getAttribute('aria-disabled') === 'true' ? ', sold out' : ', selected'); }
        disarm(); say([words]);
      }
      return;
    }
    /* Size or color row: the name, or the only value, was tapped */
    var opt = t.closest('.variant-option');
    if (opt && !t.closest('label')) { disarm(); say([readOption(opt)]); return; }
    var cat = t.closest('[data-filter], [data-filter-link]');
    if (cat) { disarm(); readCategory(cat); return; }
    var add = t.closest('.lx-card__add button, button[name="add"], [type="submit"][name="add"]');
    if (add) {
      var card = add.closest('.lx-card'), n = card && card.querySelector('.lx-card__title');
      disarm();
      say(['Adding ' + (n ? n.textContent.trim() + ' ' : '') + 'to your bag.']);
      return;
    }
    var ctl = t.closest('button, [role="button"], label, a, summary');
    if (ctl) {
      var words = ctl.tagName === 'A' ? describeLink(ctl) : (ctl.getAttribute('aria-label') || textOf(ctl));
      var fs = ctl.closest('fieldset'), lg = fs && fs.querySelector('legend');
      if (ctl.tagName === 'LABEL') { lastLabel = Date.now(); if (lg) { var ln = textOf(lg); words = ln + ' ' + sayVal(ln, words) + ', selected'; } }
      if (words) { disarm(); say([words]); }
      return;
    }
    var block = t.closest(BLOCKS);
    if (block && shown(block) && block.closest('main, footer')) { disarm(); say([textOf(block)]); return; }
    readPage();
  });
  if (canSpeak) window.addEventListener('pagehide', function () { synth.cancel(); });

  /* ---------- Small bar while Read aloud is on ---------- */
  var bar = null;
  function showBar(onNow) {
    if (!canSpeak) return;
    if (!onNow) { if (bar) bar.hidden = true; return; }
    if (!bar) {
      if (!document.body) return;
      bar = document.createElement('div');
      bar.className = 'lx-read-bar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Read aloud controls');
      if (document.querySelector('main[data-template^="product"]')) bar.classList.add('lx-read-bar--raised');
      bar.innerHTML = '<span class="lx-read-bar__label">Read aloud on</span><button type="button" data-act="page">Read page</button><button type="button" data-act="stop">Stop</button><button type="button" data-act="speed"><span class="lx-read-bar__pre">Speed: </span><span class="lx-read-bar__speed"></span></button><button type="button" data-act="off">Turn off</button>';
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-act]');
        if (!b) return;
        var act = b.getAttribute('data-act');
        if (act === 'page') readPage();
        if (act === 'stop') { disarm(); hush(); }
        if (act === 'speed') setSpeed(SPEEDS[(SPEEDS.indexOf(speed()) + 1) % SPEEDS.length]);
        if (act === 'off') { state.listen = false; save(); apply(); syncOpts(); }
      });
      document.body.appendChild(bar);
      syncSpeed();
    }
    bar.hidden = false;
  }
  function syncOpts() {
    document.querySelectorAll('.lx-a11y__opt[data-opt]').forEach(function (b) {
      var v = !!state[b.getAttribute('data-opt')];
      b.setAttribute('aria-pressed', v ? 'true' : 'false');
      b.querySelector('.lx-a11y__state').textContent = v ? 'On' : 'Off';
    });
  }

  /* ---------- The menu ---------- */
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="4.5" r="2"/><path d="M4 8.5l8 1.5 8-1.5M12 10v5M12 15l-3.5 6M12 15l3.5 6"/></svg>';
  function build() {
    if (document.querySelector('.lx-a11y')) return;
    var wrap = document.createElement('div');
    wrap.className = 'lx-a11y';
    if (document.querySelector('main[data-template^="product"]')) wrap.classList.add('lx-a11y--raised');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lx-a11y__btn';
    btn.setAttribute('aria-label', 'Accessibility options');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'lx-a11y-panel');
    btn.innerHTML = ICON;

    var panel = document.createElement('div');
    panel.className = 'lx-a11y__panel';
    panel.id = 'lx-a11y-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-labelledby', 'lx-a11y-title');
    panel.hidden = true;

    var head = document.createElement('div');
    head.className = 'lx-a11y__head';
    var h = document.createElement('h2');
    h.id = 'lx-a11y-title';
    h.className = 'lx-a11y__title';
    h.tabIndex = -1;
    h.textContent = 'Accessibility options';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'lx-a11y__close';
    close.setAttribute('aria-label', 'Close accessibility options');
    close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    head.appendChild(h); head.appendChild(close);
    panel.appendChild(head);

    var list = document.createElement('div');
    list.className = 'lx-a11y__list';
    OPTS.forEach(function (o) {
      if (o.speak && !canSpeak) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lx-a11y__opt' + (o.speak ? ' lx-a11y__opt--read' : '');
      b.setAttribute('data-opt', o.id);
      b.setAttribute('aria-pressed', state[o.id] ? 'true' : 'false');
      b.innerHTML = '<span class="lx-a11y__name"></span><span class="lx-a11y__hint"></span><span class="lx-a11y__state" aria-hidden="true"></span>';
      b.querySelector('.lx-a11y__name').textContent = o.label;
      b.querySelector('.lx-a11y__hint').textContent = o.hint;
      b.querySelector('.lx-a11y__state').textContent = state[o.id] ? 'On' : 'Off';
      b.addEventListener('click', function () {
        state[o.id] = !state[o.id];
        save(); apply(); syncOpts();
        if (o.id === 'listen' && state.listen) { open(false); readPage(); }
      });
      list.appendChild(b);
      if (o.speak) {
        var row = document.createElement('div');
        row.className = 'lx-a11y__speed';
        row.setAttribute('role', 'group');
        row.setAttribute('aria-labelledby', 'lx-a11y-speed-label');
        row.innerHTML = '<span class="lx-a11y__speed-label" id="lx-a11y-speed-label">Reading speed</span>';
        SPEEDS.forEach(function (v) {
          var sb = document.createElement('button');
          sb.type = 'button';
          sb.setAttribute('data-speed', v);
          sb.textContent = SPEED_NAME[v];
          sb.addEventListener('click', function () { setSpeed(v); });
          row.appendChild(sb);
        });
        list.appendChild(row);
        var vrow = document.createElement('div');
        vrow.className = 'lx-a11y__speed lx-a11y__voice';
        vrow.setAttribute('role', 'group');
        vrow.setAttribute('aria-labelledby', 'lx-a11y-voice-label');
        vrow.innerHTML = '<span class="lx-a11y__speed-label" id="lx-a11y-voice-label">Voice</span>';
        ['female', 'male'].forEach(function (v) {
          var vb = document.createElement('button');
          vb.type = 'button';
          vb.setAttribute('data-voice', v);
          vb.textContent = VOICE_NAME[v];
          vb.addEventListener('click', function () { setVoice(v); });
          vrow.appendChild(vb);
        });
        list.appendChild(vrow);
      }
    });
    panel.appendChild(list);

    var foot = document.createElement('div');
    foot.className = 'lx-a11y__foot';
    var reset = document.createElement('button');
    reset.type = 'button';
    reset.className = 'lx-a11y__reset';
    reset.textContent = 'Reset all';
    reset.addEventListener('click', function () { state = {}; save(); apply(); syncOpts(); syncSpeed(); syncVoice(); });
    var link = document.createElement('a');
    link.className = 'lx-a11y__link';
    link.href = '/pages/accessibility';
    link.textContent = 'Accessibility statement';
    foot.appendChild(reset); foot.appendChild(link);
    panel.appendChild(foot);

    function open(show) {
      panel.hidden = !show;
      btn.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (show) { panel.scrollTop = 0; h.focus(); } else btn.focus();
    }
    btn.addEventListener('click', function () { open(panel.hidden); });
    close.addEventListener('click', function () { open(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) open(false); });
    document.addEventListener('click', function (e) { if (e.isTrusted && !panel.hidden && !wrap.contains(e.target)) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });

    wrap.appendChild(panel);
    wrap.appendChild(btn);
    document.body.appendChild(wrap);
    showBar(!!state.listen);
    syncSpeed();
    syncVoice();
  }

  apply();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { build(); apply(); });
  else { build(); apply(); }
  window.addEventListener('load', function () { if (state.motion) apply(); });
})();
